var headerMobileWidget;

(function() {
    'use strict';
    if (!document.querySelector('#vue-mobile-header')) {
        return;
    }

    headerMobileWidget = new Vue({
        el: '#vue-mobile-header',
        data: function() {
            return {
                domEl: null,

                scrollOffset: 100,
                scrolling: false,
                scrollDelta: 10,
                previousTop: 0,
                currentTop: 0,

                initialized: false,
            };
        },
        computed: {},
        methods: {
            openMenu: function() {
                MpEventBus.$emit('openMenu');
            },

            onScroll: function() {

                this.currentTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

                if ((this.previousTop - this.currentTop) > this.scrollDelta) {
                    // scrolling up...
                    this.domEl.classList.remove('mobile-header--hidden');
                } else if ((this.currentTop - this.previousTop) > this.scrollDelta && (this.currentTop > this.scrollOffset) && !MpMobileMenu.isOpen) {
                    // scrolling down...
                    this.domEl.classList.add('mobile-header--hidden');
                }

                this.previousTop = this.currentTop;
                this.scrolling = false;
            },

            init: function() {
                var _this = this;

                if (this.initialized) {
                    return;
                }

                this.initialized = true;
                this.domEl = this.$el;

                window.addEventListener('scroll', function() {
                    if (!_this.scrolling) {
                        _this.scrolling = true;

                        if (!window.requestAnimationFrame) {
                            setTimeout(_this.onScroll, 250);
                        } else {
                            requestAnimationFrame(_this.onScroll);
                        }
                    }
                });
            },
        },
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();
